var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { loadModelFromConfig } from "@rendering/vortex-modeled-products";
import { getAssetContentUrl, queryLinksBySkuAndVariables } from "./assetLoader";
import { loadFinishMap, loadSubstrateMap } from "./materialLoader";
const DEGREES_TO_RADIANS = Math.PI / 180;
// Filter the assets by a specific tenant
function filterByTenant(links, tenant) {
  return links.find(link => link.tenant.id === tenant.id && link.tenant.type === tenant.type);
}
function convertRotationToRadians(configRotationOffset) {
  let rotationOffset = {
    yaw: 0,
    pitch: 0,
    roll: 0
  };
  if (configRotationOffset) {
    // convert degrees to radians for rotation
    rotationOffset = {
      yaw: configRotationOffset.yaw * DEGREES_TO_RADIANS,
      pitch: configRotationOffset.pitch * DEGREES_TO_RADIANS,
      roll: configRotationOffset.roll * DEGREES_TO_RADIANS
    };
  }
  return rotationOffset;
}
export function getModelProduct(productConfig) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    const response = yield fetch(productConfig.productDataUrl);
    if (!response.ok) {
      if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
        const data = yield response.json();
        throw new Error("Failed to fetch ModelData from '".concat(productConfig.productDataUrl, "': ").concat(JSON.stringify(data), "}"));
      }
      throw new Error("Failed to fetch ModelData from '".concat(productConfig.productDataUrl, "'!"));
    }
    const modelData = yield response.json();
    const surfaceIds = Object.keys(productConfig.surfaceMapping);
    const surfaceMapping = {};
    const substrateMap = yield loadSubstrateMap(productConfig);
    const finishMap = yield loadFinishMap(productConfig);
    // Build the surface mapping
    for (const surfaceId of surfaceIds) {
      const productSurface = productConfig.surfaceMapping[surfaceId];
      if (!modelData.surfaceData[surfaceId]) {
        throw new Error("The model data does not contain surface '".concat(surfaceId, "'!"));
      }
      surfaceMapping[surfaceId] = {
        page: productSurface.page,
        substrate: substrateMap[productSurface.substrateId],
        fullBleed: modelData.surfaceData[surfaceId].fullBleed,
        trim: modelData.surfaceData[surfaceId].trim,
        focalPoint: productSurface.focalPoint,
        alias: modelData.surfaceData[surfaceId].alias
      };
      // Add premium finishes if they exist
      if (productSurface.finishIds) {
        surfaceMapping[surfaceId].finishes = productSurface.finishIds.map(id => finishMap[id]);
      }
    }
    const modelConfig = {
      type: modelData.type,
      modelUri: modelData.modelUrl,
      productMapping: surfaceMapping,
      fullBleed: {
        width: 0,
        height: 0
      },
      rotationOffset: convertRotationToRadians(modelData.rotationOffset),
      positionOffset: modelData.positionOffset,
      modelStates: productConfig.modelStates
    };
    return loadModelFromConfig(modelConfig);
  });
}
export function getModelProductFromMcpSku(bearerToken, referenceId, attributes, tenant) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    const links = yield queryLinksBySkuAndVariables(bearerToken, referenceId, attributes, tenant);
    const tenantLink = filterByTenant(links, tenant);
    const fallbackLink = filterByTenant(links, {
      id: "cimpressVortex",
      type: "fulfillers"
    });
    const assetId = (tenantLink === null || tenantLink === void 0 ? void 0 : tenantLink.assetId) || (fallbackLink === null || fallbackLink === void 0 ? void 0 : fallbackLink.assetId);
    // An asset was found, pull the information and load it for vortex
    if (assetId) {
      const url = getAssetContentUrl(assetId);
      const response = yield fetch(url);
      if (!response.ok) {
        if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
          const data = yield response.json();
          throw new Error("Failed to fetch ModelData from '".concat(url, "': ").concat(JSON.stringify(data), "}"));
        }
        throw new Error("Failed to fetch ModelData from '".concat(url, "'!"));
      }
      const modelData = yield response.json();
      return getModelProduct(modelData);
    }
    return undefined;
  });
}